import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { styled } from '@mui/material/styles';
import { Grid, Typography } from '@mui/material';
const Root = styled('div')(({ theme }) => ({
    flexGrow: 1,
}));
const Item = styled('div')(({ theme }) => ({ marginBottom: theme.spacing(2) }));
const Label = styled(Typography)(({ theme }) => ({ marginBottom: theme.spacing(1) }));
const Value = styled(Typography)(({}) => ({}));
const Image = styled('img')(({ theme }) => ({ height: theme.spacing(16) }));
const Icon = styled('img')(({ theme }) => ({
    width: theme.spacing(16),
    height: theme.spacing(16),
    filter: theme.palette.mode === 'dark' ? 'invert(1)' : '',
    opacity: theme.palette.mode === 'dark' ? 1 : 0.87,
}));
const List = styled('div')(({ theme }) => ({ paddingLeft: theme.spacing(1) }));
const Content = ({ gridSize = 12, items = [], components = [] }) => {
    return (_jsxs(Root, Object.assign({ className: "content" }, { children: [_jsx(_Fragment, { children: _jsx(Grid, Object.assign({ container: true, spacing: 4 }, { children: items
                        .filter((i) => i !== null)
                        .map((i) => i)
                        .map((i) => (_jsx(Grid, Object.assign({ item: true, xs: gridSize }, { children: _jsxs(Item, { children: [_jsxs(_Fragment, { children: [!i.hideLabel && _jsxs(Label, Object.assign({ variant: "subtitle2" }, { children: [i.label, ":"] })), i.value && _jsx(Value, Object.assign({ variant: "body1" }, { children: i.value })), i.image && _jsx(Image, { src: i.image, alt: i.label }), i.icon && _jsx(Icon, { src: i.icon, alt: i.label }), i.list && (_jsx(List, { children: i.list
                                                .filter((i) => i)
                                                .map((i) => (_jsx("div", { children: i }, i))) }))] }), _jsx(_Fragment, { children: i.components })] }, i.label) }), i.label))) })) }), _jsx(_Fragment, { children: components })] })));
};
export default Content;
//# sourceMappingURL=content.js.map